/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["cs"] = {
    wikiLinkLabel:  "Diskuze"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/cs/timeline.js
// module id = 576
// module chunks = 3